import { LanguagePicker } from '@/components/common/LanguagePicker';
import { cn } from '@/lib/utils';

interface UnifiedLanguageSwitcherProps {
  variant?: 'compact' | 'full' | 'floating';
  className?: string;
}

export const UnifiedLanguageSwitcher = ({ variant = 'compact', className }: UnifiedLanguageSwitcherProps) => {
  if (variant === 'floating') {
    return (
      <div className={cn('fixed top-4 right-4 z-50', className)}>
        <LanguagePicker variant="floating" />
      </div>
    );
  }

  return (
    <LanguagePicker
      variant="compact"
      className={cn(
        variant === 'full' ? 'h-10 max-w-[240px]' : undefined,
        className
      )}
    />
  );
};
